import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empresa-painel',
  templateUrl: './empresa-painel.component.html',
  styleUrls: ['./empresa-painel.component.scss']
})
export class EmpresaPainelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
